<div class="codebox d-flex flex-column align-items-center justify-content-center">
  <div class="d-flex">
    <p class="d-flex flex-column justify-content-center align-items-center kh-heading-sm kh-heading-sm-mob pb-2">
      Folder Name
    </p>
    <div class="close-modal-icon" (click)="closeModal()">
      <fa-icon [icon]="['fas','times']"></fa-icon>
    </div>
  </div>

  <div class="info d-flex flex-column align-items-center justify-content-center w-100">
    <div class="code-input mb-3">
      <kh-common-input
        [controlType]="inputTypes.Text"
        [placeholder]="localizedNewFolderName"
        [(ngModel)]="folderName"
        testId="folder-name-form">
      </kh-common-input>
    </div>
    <div class="d-flex justify-content-end w-100 gap-2">
      <button class="kh-secondary-button mr-kh-2" (click)="closeModal()" type="button">Cancel</button>
      <button class="kh-primary-button" 
              (click)="createFolder()" 
              [disabled]="!folderName || folderName.trim() === ''">
        <span *ngIf="!isProcessing">Create</span>
        <span *ngIf="isProcessing">Submitting...</span>
      </button>
    </div>
  </div>
</div>


